<template>
  <div>
    <multiselect
        style=" float: left; width: 94%;"
        v-model="gateGroupSelected"
        id="groupSelect"
        :options="gateGroupOptions"
        :multiple="true"
        :taggable="true"
        @remove="onRemove"
        @open="updateGateGroup"
        @close="closeDropdown"
        @tag="addTag"
        @search-change="asyncSearch"
        @select="onSelectGroup"
        tag-placeholder="ゲートグループの追加"
        :show-labels="false"
        select-label=""
        remove-label=""
        :placeholder="inputPlaceholder"
        :hide-selected="true"
        :show-no-options="false"
        :max-height="140"
        :disabled="isDisabled"
        :internal-search="false"
        :clear-on-select="true"
        :close-on-select="false"
        :max="maxSelected"
        label="name"
        track-by="name">
        <template slot="tag" slot-scope="props">
          <span class="multiselect__tag" v-if="props.option.isNew" style="background: #007f41">
            <span>{{props.option.name}}</span>
             <span  v-if="props.option.groupId !== undefined">
                ({{ props.option.groupId }})
            </span>
            <i aria-hidden="true" tabindex="1" @click="props.remove(props.option)" class="multiselect__tag-icon" style="background: #007f41"></i>
          </span>
          <span class="multiselect__tag" v-else style="background: #468fcc">
            <span>{{props.option.name}}</span>
            <span  v-if="props.option.groupId !== undefined">
                ({{ props.option.groupId }})
            </span>
            <i aria-hidden="true" tabindex="1" @click="props.remove(props.option)" class="multiselect__tag-icon" style="background: #468fcc"></i>
          </span>
        </template>

        <template slot="option" slot-scope="props">
            <span v-if="props.option.isTag !== true">
                {{props.option.name}}
                <span  v-if="props.option.groupId !== undefined">
                ({{ props.option.groupId }})
            </span>
            </span>
            <span>
                <span v-if="props.option.isTag === true">{{ props.search }}</span>
            </span>
        </template>
        <span slot="noResult" style="color:red">入力されたゲートグループ名は既に使用されています。他のゲートグループ名を入力してください。</span>
        <span slot="maxElements" style="color:red">設定上限を超えております。</span>
    </multiselect>
    <div style=" float: right; width: 5%;">
      <i id="group-reload" style="font-size: 24px;color: #000000;padding-top: 7px;padding-left: 10px; float:left" class="glyphicon glyphicon-refresh"  v-if="isDisabled && isFinishGetDataGroup" @click="reloadGateGroup"></i>
    </div>
  </div>
</template>

<script>
import multiselect from 'vue-multiselect'
import * as Config from '../../config'
export default {
  props: [
    'userId',
    'loading',
    'gateGroupErrorMessage',
    'isFinishGetDataGroup',
    'isFinishAddGroup',
    'GroupIdSubmittedFail',
    'startAddGroup',
    'resetDataGroupPcode'],

  components: { multiselect },

  data () {
    return {
      gateGroupSelected: [],
      gateGroupAll: [],
      isDisabled: true,
      listGroupQuery: {
        currPage: 1,
        gateGroupListPerPagesize: 1000
      },
      gateGroupOptions: [],
      groupSubmitFail: [],
      exeAddGroupToUser: 0,
      inputPlaceholder: 'ゲートグループを選択してください。新しくゲートグループを作成する場合は新規ゲートグループ名を入力してください。',
      maxSelected: 20
    }
  },
  created () {
    this.reloadGateGroup()
  },
  mounted () {
    $('#groupSelect').css('display', 'none')
  },
  watch: {
    resetDataGroupPcode: function (newVal, oldVal) {
      if (newVal) {
        this.reloadGateGroup(1)
      }
    },
    startAddGroup: function (newVal, oldVal) {
      if (newVal) {
        this.exeAddGroupToUser = 1
      } else {
        this.exeAddGroupToUser = 0
      }
    },
    exeAddGroupToUser: function (newVal, oldVal) {
      var vm = this
      console.log('exeAddGroupToUser - value ', newVal, ' - ', oldVal)
      if (newVal > 0) {
        if (newVal <= vm.gateGroupSelected.length) {
          if (vm.gateGroupSelected[oldVal].isNew === undefined) {
            vm.addGateGroupToUser(vm.gateGroupSelected[oldVal].groupId, vm.userId)
          } else {
            //  register group
            vm.registerNewGateGroup(vm.gateGroupSelected[oldVal])
          }
        } else {
        //   finish
          this.$emit('update:isFinishAddGroup', true)
          this.$emit('update:GroupIdSubmittedFail', this.groupSubmitFail)
        }
      }
    }
  },
  methods: {
    getAllGateGroupList (page) {
      // this.$emit('update:loading', true)
      this.$http.get(Config.GROUPS_LIST_API + '?limit=' + this.listGroupQuery.gateGroupListPerPagesize + '&page=' + page + '&keyword=' + '' + '&isValid=true')
        .then(response => {
          console.log(response)
          this.inputPlaceholder = 'ゲートグループを選択してください。新しくゲートグループを作成する場合は新規ゲートグループ名を入力してください。'
          if (response.body.maxRecords > 0) {
            var groupListTemp = response.body.groups
            groupListTemp.forEach(element => {
              this.gateGroupAll.push(element)
              this.gateGroupOptions.push(element)
            })
            if (response.body.maxRecords > response.body.endRecord) {
              this.listGroupQuery.currPage = page + 1
              this.getAllGateGroupList(this.listGroupQuery.currPage)
            } else {
              this.isDisabled = false
              this.$emit('update:isFinishGetDataGroup', true)
            }
          } else {
            this.isDisabled = false
            this.$emit('update:isFinishGetDataGroup', true)
          }
        })
        .catch((error) => {
          this.inputPlaceholder = '該当するデーターがありません。'
          this.$emit('update:isFinishGetDataGroup', true)
          this.isDisabled = true
          this.gateGroupAll = []
          this.gateGroupOptions = []
          console.log(error)
        })
    },
    reloadGateGroup () {
      this.$emit('update:isFinishGetDataGroup', false)
      this.gateGroupSelected = []
      this.gateGroupAll = []
      this.gateGroupOptions = []
      this.groupSubmitFail = []
      this.getAllGateGroupList(1)
    },
    updateGateGroup () {
      this.$emit('update:gateGroupErrorMessage', '')
      $('#groupSelect').css('display', 'unset') // Show completely input
    },
    closeDropdown (value, id) {
      $('#groupSelect').css('display', 'none') // Hide completely input
    },
    addTag (newTag) {
      const newGateGroup = {
        name: newTag,
        isNew: true
      }
      if (this.validateBeforeSubmit(newGateGroup)) {
        this.gateGroupAll.unshift(newGateGroup)
        this.gateGroupOptions.unshift(newGateGroup)
        this.gateGroupSelected.push(newGateGroup)
      }
    },
    onRemove (groupRemove, id) {
      if (groupRemove.isNew !== undefined && groupRemove.isNew) {
        this.gateGroupAll.splice(this.gateGroupAll.indexOf(groupRemove), 1)
      }
      this.gateGroupOptions = this.gateGroupAll
    },
    asyncSearch (query) {
      this.gateGroupOptions = this.gateGroupAll.filter(function (el) {
        return el.name.toLowerCase().includes(query.toLowerCase().trim()) || (el.groupId !== undefined ? el.groupId.toLowerCase().includes(query.toLowerCase().trim()) : false)
      })
    },
    validateBeforeSubmit (group) {
      var isValid = false
      if (group.name === null || group.name === '') {
        isValid = false
        this.$emit('update:gateGroupErrorMessage', 'ゲートグループ名は必須です。')
      } else if (group.name !== null && group.name !== '') {
        if (group.name.length > 64) {
          isValid = false
          this.$emit('update:gateGroupErrorMessage', 'ゲートグループ名は64文字以内で入力してください。')
        } else {
          isValid = true
          this.$emit('update:gateGroupErrorMessage', '')
        }
      }
      return isValid
    },
    registerNewGateGroup (group) {
      var vm = this
      const Infor = {
        name: group.name,
        isValid: true
      }
      this.$http.post(Config.GROUPS_LIST_API, Infor)
        .then(response => {
          console.log(response)
          vm.addGateGroupToUser(response.body.groupId, this.userId)
        })
        .catch(error => {
          this.exeAddGroupToUser++
          vm.groupSubmitFail.push(group)
          console.log(error)
        })
    },
    addGateGroupToUser (groupId, userId) {
      var vm = this
      this.$http.post(Config.GROUPS_PASSAGE_API, {groupId: groupId, userId: userId})
        .then(response => {
          console.log(response)
          vm.exeAddGroupToUser++
        })
        .catch(error => {
          console.log(error)
          vm.exeAddGroupToUser++
          vm.groupSubmitFail.push(groupId)
        })
    },
    onSelectGroup () {
      this.$emit('update:gateGroupErrorMessage', '')
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
#group-reload:active {
  color: #a7a7a7 !important
}
</style>



// WEBPACK FOOTER //
// src/views/user/UserGateGroupSelect.vue